import { filter, propEq, keys } from 'ramda'
import formatContent from '@/utils/format-content'
import stripHTML from '@/utils/strip-html'

const formatAddendumPreview = (addendum, t, variables) => {
  const getSelectedOptions = () => {
    const selectedOptions = keys(filter(propEq('selected', true))(addendum.metadata.options))
    return selectedOptions
      .map(option => `${t(`l.contract.edit.addendum_modal_smoking_${option}.label`)}`)
      .join(', ')
  }

  const formatOptions = metadata => {
    return metadata?.allowed
      ? `${t('b.contract.view.addendum_allowed.text', 'Allowed')}: ${getSelectedOptions()}`
      : t('b.contract.view.addendum_not_allowed.text', 'Not allowed')
  }

  return addendum.data_type === 'options'
    ? formatOptions(addendum.metadata)
    : variables
    ? stripHTML(formatContent(addendum.content, variables))
    : stripHTML(addendum.content)
}

export default formatAddendumPreview
